import React, { useState } from "react";
import "./ConfigPage.css";
import { TagManager } from "../model/TagManager";
import { AppStateReadableSerializer } from "../model/AppStateReadableSerializer";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import LogoBar from "./LogoBar";

type ConfigPageProps = {
	tagManager: TagManager;
};

const ConfigPage: React.FunctionComponent<ConfigPageProps> = (
	props: ConfigPageProps
) => {
	let state = props.tagManager.readState();

	const [dirty, setDirty] = useState(false);
	const [text] = useState(AppStateReadableSerializer.stateToReadable(state));

	let markDirty = () => setDirty(true);

	let saveState = () => {
		let readableTagsToSave = document.getElementById("readableTags")
			?.innerText;
		if (readableTagsToSave) {
			let newAppState = AppStateReadableSerializer.readableToState(
				readableTagsToSave
			);
			if (newAppState) {
				props.tagManager.saveAppState(newAppState);
			}
		}
		setDirty(false);
	};

	return (
		<div className="ConfigPage">
			<LogoBar />
			<div className="Page-navbar w3-bar w3-top noselect">
				<Link to="/" className="w3-bar-item w3-button w3-left">
					<FontAwesomeIcon
						icon={faArrowLeft}
						className="Page-navbar-icon"
					/>
				</Link>
				{dirty ? (
					<button
						className="w3-bar-item w3-button w3-right w3-green"
						onClick={saveState}
					>
						Save
					</button>
				) : (
					""
				)}
				<Link
					to="/configactions"
					className="w3-bar-item w3-button w3-right"
				>
					More...
				</Link>
			</div>

			<div className="Page-content w3-container">
				<h1 className="noselect w3-center">Edit your tag set</h1>
				<div
					id="readableTags"
					className="ConfigPage-textarea"
					contentEditable="true"
					suppressContentEditableWarning={true}
					onInput={markDirty}
					dangerouslySetInnerHTML={{ __html: text ?? "" }}
				></div>
			</div>
		</div>
	);
};

export default ConfigPage;
